import { Select, styled, Theme, Toolbar } from '@mui/material';
import { brightpathTheme } from '@youscience/theme';
import ActionButton from '@components/ActionButton';

export const sxStyles = {
  headTitle: {
    fontSize: '36px',
    marginTop: '0.5rem',
  },
  headSubtitle: (theme: Theme) => ({
    color: theme.palette.grey['700'],
  }),
  editIcon: (theme: Theme) => ({
    fill: theme.palette.common.white,
  }),
  tableWrap: {
    display: 'flex',
    flexDirection: 'column',
    gap: '1rem',
    padding: '2rem 2.5rem',
  },
  headRow: {
    height: '40px',
  },
  tableBodyRow: (theme: Theme) => ({
    borderTop: `1px solid ${theme.palette.grey['300']}`,
    height: '52px',

    '&:hover': {
      cursor: 'pointer',
      backgroundColor: '#EBF6F7',
    },
  }),
  paper: {
    position: 'relative',
    borderRadius: '12px',
  },
  flexAlignPosition: {
    gap: '1rem',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  searchWrap: (theme: Theme) => ({
    maxWidth: '220px',

    '& > div:first-of-type': {
      '& .MuiInputBase-root': {
        borderRadius: '4px',
        border: `1px solid ${theme.palette.grey['300']}`,
        backgroundColor: '#F9F9F9',
      },
    },
  }),
  loader: {
    position: 'absolute',
    top: '6rem',
    left: '50%',
  },
  cancelEditIcon: (theme: Theme) => ({
    '& > svg:first-of-type': {
      scale: '1.4',
      fill: theme.palette.error.dark,
    },
  }),
};

export const StyledHeadSectionInner = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  width: '100%',
  padding: '0 2.5rem 2rem 2.5rem',
  borderBottom: `1px solid ${theme.palette.grey['300']}`,

  [theme.breakpoints.down('xs')]: {
    padding: '0 1.25rem',
  },
}));

export const StyledHeadTitlesWrap = styled('div')(() => ({
  display: 'flex',
  flexDirection: 'column',
  gap: '0.5rem',
  maxWidth: '900px',
  width: '100%',
}));

export const StyledToolbar = styled(Toolbar)(({ theme }) => ({
  display: 'flex',
  flexWrap: 'wrap',
  flexDirection: 'row',
  justifyContent: 'space-between',
  padding: '0 !important',

  [theme.breakpoints.down('xs')]: {
    gap: '1rem',
    flexDirection: 'column',
    justifyContent: 'start',
  },
}));

export const StyledFilterSelect = styled(Select)(({ theme }) => ({
  color: brightpathTheme.palette.secondary.main,
  marginLeft: '0.5rem',

  '.MuiOutlinedInput-input': {
    fontSize: '0.875rem',
    padding: '0.5rem 1rem',
    marginRight: '0.35rem',
  },

  '.MuiOutlinedInput-notchedOutline': {
    borderRadius: '40px',
    border: `1px solid ${brightpathTheme.palette.secondary.main}`,
    borderColor: `${brightpathTheme.palette.secondary.main} !important`,
  },

  '& > svg:first-of-type': {
    color: brightpathTheme.palette.secondary.main,
  },

  '&:hover': {
    '.MuiOutlinedInput-notchedOutline': {
      border: `1px solid ${brightpathTheme.palette.secondary.dark}`,
    },
  },

  [theme.breakpoints.down('xs')]: {
    width: '100%',
  },
}));

export const StyledTotalEducators = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  padding: '0.225rem 0.75rem',
  border: `1px solid ${theme.palette.grey['600']}`,
  backgroundColor: theme.palette.grey['100'],
  borderRadius: '8px',
  fontSize: '0.813rem',
}));

export const StyledRowEditIcon = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: '32px',
  height: '32px',
  borderRadius: '40px',

  '&:hover': {
    cursor: 'pointer',
    background: theme.palette.grey[100],
  },

  '& > svg:first-of-type': {
    fill: theme.palette.grey['600'],
  },
}));

export const StyledEditRolesButton = styled(ActionButton)(({ theme }) => ({
  '& > span > svg:first-of-type': {
    fill: theme.palette.common.white,
  },
}));
